import React from 'react';
import './KingdomSelector.css';

class KingdomButton extends React.Component
{
    onClick = () => {
        
        this.props.onSelected(this.props.faction, this.props.character);
    }

    render()
    {
        const character = this.props.character;
        const isSelected = this.props.isSelected;
        const buttonClass = isSelected ? "kingdom-button-selected" : "kingdom-button";
        const iconClass = isSelected ? "kingdom-banner-selected" : "kingdom-banner";

        return (
            <span className={buttonClass} onClick={this.onClick}>
                <img className={iconClass} src={require('../Resources/' + character + '.png')} alt="imageNotFound" title={character}/>
            </span>
        );
    }
}

export default KingdomButton;